import { FC } from 'react';

import { Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';

import { CustomMenuItemProps } from './interfaces';

const CustomMenuItem: FC<CustomMenuItemProps> = ({
  Icon,
  text,
  textProps,
  iconProps,
  ...props
}) => {
  return (
    <MenuItem {...props}>
      <Icon
        fontSize="inherit"
        {...iconProps}
        style={{ marginRight: 8, ...iconProps?.style }}
      />
      <Typography variant="body2" {...textProps}>
        {text}
      </Typography>
    </MenuItem>
  );
};

export default CustomMenuItem;
